import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-home-page-total-multa',
  templateUrl: './home-page-total-multa.component.html',
  styleUrls: ['./home-page-total-multa.component.scss']
})
export class HomePageTotalMultaComponent implements OnInit {
  @Input() multas:any;
  total:number=0;
  cuotas:number=0;
  constructor() { }

  ngOnInit() {
   
    this.multas.forEach(element => {
      this.total+=this.round(element.abono);
      // if(element.cuotas.length>0){
      //   element.cuotas.forEach(elementc => {
      //     this.cuotas+=elementc.abono;
      //   });
      // }
    });
    this.total=this.round(this.total-this.cuotas);
  }

  round(num: any, decimales = 2) {
		let signo: any = (num >= 0 ? 1 : -1);
		num = num * signo;
		if (decimales === 0) //con 0 decimales
			return signo * Math.round(num);
		// round(x * 10 ^ decimales)
		num = num.toString().split('e');
		num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
		// x * 10 ^ (-decimales)
		num = num.toString().split('e');
		let val: any = num[0] + 'e';
		return signo * (val + (num[1] ? (+num[1] - decimales) : -decimales));
	}

}
